module.exports = __webpack_public_path__ + "assets/img/urlIcon.7eeddbfc.svg";